module.exports = {"description":"The Collector is an unplayable Universal Champion"}


//////////////////
// WEBPACK FOOTER
// ./src/data/guides/collector.json
// module id = 426
// module chunks = 0